import MapWithMarkers from '@/components/map-with-markers';
import { StoreEntity } from '@/services/types/store.type';
import { Coordinates } from '@/types/map.type';
import { MarkerType } from '@/types/marker.type';

interface Props {
  branches: StoreEntity[];
}
const MapSection = ({ branches }: Props) => {
  // const markers: MarkerType[] = branches.map((branch) => ({
  //   loc: [branch.longitude, branch.latitude] as Coordinates,
  //   title: branch.name,
  // }));
  const markers: MarkerType[] =
    branches.length == 0
      ? [
          {
            loc: [127.0668649, 37.5079838],
            title: '직영본점',
          },
        ]
      : branches.map((branch) => ({
          loc: [branch.longitude, branch.latitude] as Coordinates,
          title: branch.name,
        }));
  return (
    <section className="flex w-full items-center justify-center">
      <MapWithMarkers
        key={JSON.stringify(markers)}
        markers={markers}
        zoom={10}
      />
    </section>
  );
};

export default MapSection;
